// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3hwJs","label":"Category_label__3vrlM","content":"Category_content__7FnUO","header":"Category_header__2k89p","location":"Category_location__3nOMu"};